module.exports = __webpack_public_path__ + "img/ANTENNA 1 RED.fbfa479.svg";